import { httpClient } from '@/core/api/httpClient';
import { env } from '@/core/config/env';
import type { GuidanceProgressStatus, TenantGuidanceGuide } from '@/core/types/guidance';

export const guidanceApi = {
  list: async (): Promise<TenantGuidanceGuide[]> => {
    if (env.isDemo) return [];
    return (await httpClient.get<TenantGuidanceGuide[]>('/api/v1/guides')).data;
  },

  updateProgress: async (
    guideId: string,
    status: GuidanceProgressStatus,
    currentStep: number,
  ): Promise<TenantGuidanceGuide> =>
    (await httpClient.put<TenantGuidanceGuide>(`/api/v1/guides/${guideId}/progress`, {
      status,
      currentStep,
    })).data,
};
